
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//瑞典语

export const lang ={
  Please_set_materialtype_in_product_page:"Gå till produktsidan för att ändra och ställa in materialtypen för varje produkt - färdiga produkter - halvfabrikat - tillbehör.",
deleteAccount:"Logga ut",
deleteAccountWillDeleteAllData:"Om du loggar ut från ditt konto raderas all data och gör att du inte kan logga in.",
backupDatabase:"backup databas",
restoreDatabase:"Återställ databas",
materialtype:"Material Typ",
Manufacturing:"Tillverkningsversion",
Professional:"Professionell version",
Standard:"standard utgåva",
product:"Färdig produkt",
halfProduct:"Halvfärdiga produkter",
components:"Tillbehör",
Parent:"överordnad komponent",
Children:"Undertillbehör",
Level:"Hierarki",
Timing:"Timing",
PieceCount:"Pjäsarbete",
Wages:"Lön",
InternalProcess:"Intern process",
ExternalProcess:"extern process",
ProceName:"Process namn",
ProceIndex:"Avrättningsorder",
ChargeMan:"rektor",
BillMethod:"Faktureringsmetod",
ConsumTime:"arbetstimmar",
Accessories:"Tillbehör",
Assembly:"Montera",
materials:"material",
task:"Uppgift",
process:"bearbeta",
BOM:"BOM",
Production:"Produktion",
RestorePurchaseOneUse:"Återställ köp (en användare (begränsat till tidigare köp))",
buy_fail_try_again:"Klicka igen för att köpa",
Export:"Exportera",
Date:"datum",
BankDetail:"bankuppgifter",
Seller:"säljare",
Buver:"köpare",
Currency:"valuta",
CompanyName:"Företagsnamn",
ProformaInvoice:"proforma faktura",
Discount:"Rabatt",
PayStatus:"Betalningsstatus",
ShippingStatus:"Fraktstatus",
FreightType:"Transporttyp",
Shipping:"frakt",
Payment:"Betalning",
Moneyname:"valutanamn",
Tax:"skatter",
Freight:"Fraktkostnad",
Insurance:"försäkring",
Bankfee:"bankavgifter",
Qc:"Kvalitetscertifiering",
Exchangerate:"växlingskurs",
Shippingnumber:"leveransnummer",
ShipDate:"Leveransdatum",
Arrivedate:"ankomstdatum",
Grossweight:"bruttovikt",
CubicWeight:"kubikvikt",
Totalpackages:"Totalt antal paket",
Moneytype:"valutatyp",
Quotedate:"offertdatum",
Validitydate:"Giltigt datum",
Paymentterm:"lönens utgång",
Priceterm:"prissättningstid",
DeliveryTerm:"Leveranstid",
BankName:"Bank namn",
BankAddress:"bankadress",
SwiftCode:"Bankkod",
Review:"Recension",
Signfor:"Signera för mottagande",
Finance:"finansiera",
Receiver:"Mottagare",
Business:"företag",
ContactPerson:"Kontaktperson",
Profit:"vinst",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"Anställda måste använda Google Chrome. Kontrollera IP-adressen på hjälpsidan för huvudtjänstdatorns APP och ange sedan adressen i URL-kolumnen för andra datorwebbläsare för att öppna inloggningen",
newPassword:"nytt lösenord",
ForgetPassword:"glöm lösenordet",
ContactUs:"Kontakta oss/kom med förslag",
Actualpay_should_big_then_shouldpay:"Faktiska intäkter kan inte vara större än fordringar",
ShopAddress:"Min butiksadress Skanna QR-koden för att göra en beställning",
Submit:"Skicka in",
All:"Allt",
OrdernumExists:"Ordernummer finns redan",
PermissionDenied:"åtkomst nekad",
StockTransfer:"Lageröverföring",
FromWarehouse:"Överföring från lagret",
ToWarehouse:"Överföring till lager",
PleaseUseInWebBrowser:"Använd Excel-exportfunktionen i Google Chrome",
PleasePrintInWebBrowser:"Använd utskriftsfunktionen i Google Chrome",
HistoryPrice:"historiskt pris",
SerialNumber:"serienummer",
Please_Use_In_APP:"Använd den i datorprogramvara",
Please_Purchase_In_APP:"Köp i APP, inte i webbläsaren",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"Du kan ansluta till Postgresql-databasen. Dina data kommer att lagras i Postgresql-databasen. Som standard behöver du inte ansluta till Postgresql-databasen. Standard är den lokala Sqlite-databasen.",
Connect_Postgresql_database_data_will_store_in_Postgresql:"Anslut till Postgresql-databasen, dina data kommer att lagras i Postgresql-databasen och data kommer att läsas igen",
Use_sqlite_data_will_store_in_local:"Med sqlite lagras data på den lokala maskinen",
UsePostgresqlDatabase:"Använder PGSQL-databas",
UseSqliteDatabase:"Använder Sqlite-databas",
DatabaseName:"Namndatabas",
Test_connect:"testa anslutningen",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"Om produkten har en färg eller storlek, vänligen fyll i 0 för det initiala lagret. När du har lagt till produkten anger du lagret i köpet.",
my:"mina",
my_shop_qrcode_scan:"Min butiks QR-kod ger kunderna möjlighet att skanna koden för att lägga beställningar.Kundens mobiltelefon ska vara ansluten till samma router som din dator.",
ip:"IP",
port:"Hamn",
orderstatus:"Orderstatus",
image:"bild",
Template:"mall",
Please_select_a_excel_file:"Välj en fil",
Please_select_only_one_excel_file:"Endast en fil kan väljas",
Connect_Internet_Login_again:"Anslut till Internet och logga in igen innan du köper",

    productHasValidDate:'Produkten har en giltig period',
productHasColor:'Produkten har färgstorlek',
GeneralGoods:'Allmänna varor',
Selected:'Valda',
RestorePurchase:'Fortsätt köp',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'Köp fakturering Enterprise Edition 1 användare permanent',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'Köpfakturering Enterprise Edition är obegränsad för användare och enheter',
Purchasing:'Köper ... Vänta tålmodigt ...',
Validdate:'Giltighetstid',
Makedate:'Produktionsdatum',
Batch:'batch',
CheckVersion:'Kontrollera versionen',
Please_set_this_ip_address_on_App:'Ange denna IP-adress eller IP-adress för datorn på APP.',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'Öppna den här anslutningen i din dator eller mobil webbläsare (anslut samma WiFi)',


    CheckVersion: "Kontrollera version",
You_need_to_purchase: 'Du har inte köpt ännu, var god lägg till WeChat till Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: "Du har redan köpt",
New_version_available: "Det finns en ny version",
Is_the_latest_version: 'är den senaste versionen',
    please:'snälla du',
input:'inmatning',
wrong:'fel',
Verifycode:'Verifiera kod',
Upload:'Ladda upp',
Download:'Ladda ner',
You_need_to_purchase_to_continue_use:'Du måste köpa för att fortsätta använda',
CheckBuy:'Kontrollera inköp',
Exists:'Existerar',
NetworkUnavailable:'nätverk ej tillgängligt',
Today:'I dag',
Yesterday:'I går',
ThisMonth:'Den här månaden',
LastMonth:'Förra månaden',
nickname:'smeknamn',
storeName:'affärsnamn',
BuyStandAlone:'köp fristående version',
PermissionDenied:'Åtkomst nekad',
Boss:'Chef',

    login:'Logga in',
    operate:'Fungera',
    register:'Registrera',
    username:'Användarnamn',
    password:'Lösenord',
    User:'Användare',
    ok:'ok',
    back:'Tillbaka',
    success:'Framgång',
    fail:'Misslyckas',
    cancel:'Annullera',
    add:'Lägg till',
    edit:'Redigera',
    delete:'Radera',
    refresh:'Uppdatera',
    close:'Stänga',
    cancel:'Annullera',
    return:'Lämna tillbaka',
    ElinkInvoice:'Elink faktura',
    Purchase:'Inköp',
    BaseData:'Basdata',
    Sell:'Sälja',
    PurchaseReturns:'Inköpsavkastning',
    SellReturns:'Sälj avkastning',
    Inventory:'Lager',
    Statistics:'Statistik',
    Receivable:'fordran',
    Payable:'betalas',
    Orders:'Order',
    StockTransfer:'Lageröverföring',
    StockRecall:'Stock Recall',
    Customer:'Kund',
    Supplier:'Leverantör',
    Warehouse:'lager',
    Color:'Färg',
    Size:'Storlek',
    Category:'Kategori',
    Category2:'kategori 2',
    Product:'Produkt',
    Account:'konto',
    AccountType:'Konto kategori',
    Staff:'Personal',
    typeone:'Kategori',
    typetwo:'Underkategori',
    ProductName:'Produktnamn',
    Specification:'Specifikation',
    Barcode:'Streckkod',
    Buyprice:'Köppris',
    Sellprice:'Säljpris',
    Wholesaleprice:'Grossistpris',
    Currentstock:'Nuvarande lager',
    Unit:'Enhet',
    Initstock:'Init lager',
    Parameter:'Parameter',
    Remark:'Anmärka',
    Supplier:'Leverantör',
    Customer:'Kund',
    Staff:'Personal',
    Receivable:'fordran',
    payable:'betalas',
    Receipts:'Kvitton',
    Paid:'betald',
    Preferential:'Förmåns',
    DateDay:'Datum',
    OrderNum:'Ordernummer',
    Name:'namn',
    UserName:'Användarnamn',
    IdNum:'Id nummer',
    BirthDay:'Födelsedag',
    SEX:'Sex',
    Female:'Kvinna',
    Male:'Manlig',
    Select:'Välj',
    Address:'Adress',
    Phone:'Telefon',
    Email:'E-post',
    CardNum:'Kortnummer',
    Price:'Pris',
    QTY:'Antal',
    SupplierCategory:'Leverantörskategori',
    CustomerCategory:'Kundkategori',
    Power:'Kraft',
    Role:'Roll',
    save:'Spara',
    image:'bild',
    search:'Sök',
    Year:'År',
    Month:'Månad',
    Day:'Dag',
    Total:'Total',
    WorkReport:'Arbetsrapport',
    Leave:'Lämna',
    CheckIn:'Checka in',
    Announcement:'Meddelande',
    Approval:'Godkännande',
    Tracking:'spårning',
    Bill:'Räkningen',
    OrdersDetail:'Beställningsdetaljer',
    Expense:'Bekostnad',
    Income:'Inkomst',
    Userfor:'Userfor',
    Amount:'Belopp',
    Title:'Titel',
    News:'Nyheter',
    SelectFile:'Välj fil',
    Content:'Innehåll',
    Cost:'Kosta',
    ApprovalUser:'Godkännande användare',
    ApprovalStatus:'godkännandestatus',
    ApprovalRemark:'Godkännandemärkning',
    ApprovalDate:'Datum för godkännande',
    SubmitDate:'Inlämningsdatum',
    Status:'Status',
    FromDateTime:'Från Datum Tid',
    ToDateTime:'Till Datum Tid',
    Subject:'Ämne',
    Latitude:'Latitud',
    Longitude:'Longitud',
    Print:'Skriva ut',
    DataTrans:'DataTrans',
    OA:'OA',
    Setting:'Miljö',
    Help:'Hjälp',
    ScanOpenInPhone:'Skanna öppen i telefon',
    Building:'Byggnad',
    Room:'Rum',
    HotelCheckIn:'Checka in',
    CheckOut:'Checka ut',
    Hotel:'Hotell',
    Checkintime:'Incheckningstid',
    Checkouttime:'Utcheckningstid',
    Deposit:'Deposition',
    Cost:'Kosta',
    RoomNum:'Rumsnummer',
    Rent:'Hyra',
    costday:'costday',
    rent:'hyra',
    waternum:'Vatten grad',
    electricnum:'Elektrisk examen',
    gasnum:'Gas grad',
    watercost:'vatten kostnad',
    electriccost:'elektrisk kostnad',
    gascost:'gaskostnad',
    cleaningcost:'städningskostnad',
    networkcost:'nätverkskostnad',
    tvcost:'tv-kostnad',
    managecost:'hantera kostnad',
    othercost:'annan kostnad',
    totalcost:'total kostnad',
    remark:'anmärka',
    addtime:'lägg till tid',
    OpenInBrowser:'Öppna i webbläsaren',
    InventoryProfit:'Lagervinst',
    InventoryLoss:'Lagerförlust',
    Buy:'köpa',



Refresh:'Uppdatera',
Add:'Lägg till',
Search:'Sök',
Records:'poster',
}



// WEBPACK FOOTER //
// ./src/lang/sv.js